"use client";
import { useEffect, useRef } from "react";

// /programs 좌측 '상세 필터(접기)' — 검색(폼 제출=새로고침) 후에도 열림/접힘 상태를 유지.
//   서버는 defaultOpen(값 있으면 열림)으로 초기 렌더, 클라이언트는 localStorage 로 사용자가 마지막에 둔 상태를 복원.
export default function AdvancedFilterDetails({ defaultOpen, children }: { defaultOpen: boolean; children: React.ReactNode }) {
  const ref = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const saved = localStorage.getItem("programs.advOpen");
    if (saved != null) el.open = saved === "1"; // 마지막 상태 복원
    const onToggle = () => localStorage.setItem("programs.advOpen", el.open ? "1" : "0");
    el.addEventListener("toggle", onToggle);
    return () => el.removeEventListener("toggle", onToggle);
  }, []);
  return (
    <details ref={ref} open={defaultOpen} style={{ marginTop: 14, borderTop: "1px dashed #d1d5db", paddingTop: 12 }}>
      {children}
    </details>
  );
}
